const {find} = require("lodash");
const {blogName, categories, lenses, authors} = require('./const')

const extractCategory = (tags) => {
  const {slug} = find(tags, tag => tag.slug.includes('categoria_')) || {}
  return categories[slug]
}

const extractLens = (tags) => {
  const {slug} = find(tags, tag => tag.slug.includes('lente_')) || {}
  return lenses[slug]
}

const extractAuthor = (tags) => {
  const {slug} = find(tags, tag => tag.slug.includes('autore_')) || {}
  return authors[slug]
}

const urlForNode = (node) => {
  // Extract category/lens from tags
  const category = extractCategory(node.tags)
  const lens = extractLens(node.tags)

  if (!category) console.error('missing category', node)
  if (!lens) console.error('missing lens', node)

  return `/${blogName}/${category.postPath}/${lens.postPath}/${node.slug}`
}

const stringToSlug = (str) => {
  str = str.replace(/^\s+|\s+$/g, ''); // trim
  str = str.toLowerCase();

  // remove accents, swap ñ for n, etc
  var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
  var to = "aaaaeeeeiiiioooouuuunc------";
  for (var i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }

  str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
    .replace(/\s+/g, '-') // collapse whitespace and replace by -
    .replace(/-+/g, '-'); // collapse dashes

  return str;
}


exports.extractCategory = extractCategory
exports.extractLens = extractLens
exports.extractAuthor = extractAuthor

exports.urlForNode = urlForNode

exports.stringToSlug = stringToSlug
